import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import HospitalSelectListBox from '../../../../components/box/HospitalSelectListBox';
import style from './NonFaceChangePassword.module.css';
import URL from '../../../../constants/url';
import { useNavigate } from "react-router-dom";

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';


const NonFaceChangePassword = () => {

    const navigate = useNavigate();
    const onDismiss = () => setOpen(false);
    
    const [step, setStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [open, setOpen] = useState(false);
    
     // 패스워드 체크
    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [pwRules, setPwRules] = useState({
        length: false,
        number: false,
        letter: false,
        special: false,
    });

    //상태추가
    const [pwFocused, setPwFocused] = useState(false);
    const [rePwFocused, setRePwFocused] = useState(false);
   

    //비번 체크
    const handlePwView = () => {
        setPwView(!pwView);
    }
    const handleRePwView = () => {
        setRePwView(!rePwView);
    }

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        const length = value.length >= 9;
        const number = /\d/.test(value);
        const letter = /[a-zA-Z]/.test(value);
        const special = /[!@#$%^&*(),.?":{}|<>]/.test(value);

        setPwRules({ length, number, letter, special });
    };

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    //버튼 활성화 조건
    const isNextEnabled = () => {
        if (step === 1) {
            return pwRules.length && pwRules.number && pwRules.letter && pwRules.special;
        }
        if (step === 2) {
            return password && rePassword && password === rePassword;
        }
        return false;
    };

    
   
    //다음 버튼 
    const handleNext = () => {
        if (step < 5) {
            setStep(step + 1);
        } else {
            navigate(URL.NONFACE_LOGIN_MAIN, { state: { passwordChanged: true } });
        }
    };


    return (
        <>
            <HeadSub 
                title="Reset Password"
                onBack={() => {
                    if (step === 4 || step === 5) {
                    setStep(3);
                    }
                    else {
                    navigate(-1);
                    }
                }}
            />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">


                        <div className={style['content-box']}>
                            <strong className={style['title']}>
                                {'Reset your password'} 
                            </strong>

        


                        {step >= 2 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>Confirm Password</span>
                                    <div className={ style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input 
                                                type={rePwView ? "text" : "password"} 
                                                placeholder="Please re-enter your new password"
                                                value={rePassword}
                                                onChange={handleRePasswordChange}
                                                onFocus={() => setRePwFocused(true)}
                                                onBlur={() => setRePwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={rePwView ? "on" : "off"} onClick={handleRePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>

                                    {(step === 3 || rePwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            {password && rePassword && password === rePassword ? (
                                                <span className={style['on']}>Passwords match</span>
                                            ) : (
                                                <span className={style['error']}>Passwords do not match</span>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        {step >= 1 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>New Password</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input 
                                                type={pwView ? "text" : "password"} 
                                                placeholder="Please enter your new password"
                                                value={password}
                                                onChange={handlePasswordChange}
                                                onFocus={() => setPwFocused(true)}
                                                onBlur={() => setPwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={pwView ? "on" : "off"} onClick={handlePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>
                                    {(step === 2 || pwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            <span className={pwRules.length ? style['on'] : ''}>At least 9 characters</span>
                                            <span className={pwRules.letter ? style['on'] : ''}>Letter</span>
                                            <span className={pwRules.number ? style['on'] : ''}>Number</span>
                                            <span className={pwRules.special ? style['on'] : ''}>Special character</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        </div>
                        {/* 아이디 비밀번호 입력 화면:: E */}



                        {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                    disabled={!isNextEnabled()}
                                >
                                    <span>
                                        {step === 2 ? 'Confirm'
                                        :  'Next'
                                        }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={'준비중 입니다.'}
                            position="center"
                            opacity="90"
                        />
                    )}

                    
                    </div>
                </div>
        </>
    )
}

export default NonFaceChangePassword
